import React, { useCallback, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { clearAgentLinks } from 'features/auth/actions'
import { selectIsUserAuthenticated } from 'features/auth/selectors'

export const useClearNotAuthData = () => {
  const dispatch = useDispatch()
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  const clearFunc = useCallback(() => {
    dispatch(clearAgentLinks())
  }, [dispatch])

  useEffect(() => {
    if (!isAuth) {
      clearFunc()
    }
  }, [isAuth])
}
